var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 44,
    fill: "url(#paint0_linear_7416_16902)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7416_16902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5157 37.3473C55.2094 36.968 54.7649 36.726 54.2801 36.6744C53.7954 36.6228 53.3099 36.7659 52.9307 37.0723C52.5514 37.3786 52.3094 37.823 52.2578 38.3078C52.2062 38.7926 52.3494 39.278 52.6557 39.6573C53.5819 40.9166 54.0815 42.439 54.0815 44.0023C54.0815 45.5655 53.5819 47.0879 52.6557 48.3473C52.4371 48.6167 52.2995 48.9426 52.2588 49.2871C52.218 49.6317 52.2759 49.9807 52.4257 50.2936C52.5754 50.6066 52.8109 50.8706 53.1048 51.055C53.3986 51.2395 53.7387 51.3368 54.0857 51.3356C54.3596 51.3365 54.6302 51.2761 54.8776 51.1587C55.1251 51.0413 55.3431 50.87 55.5157 50.6573C56.9699 48.7434 57.7572 46.4059 57.7572 44.0023C57.7572 41.5986 56.9699 39.2611 55.5157 37.3473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.006 31.5841C57.8206 31.43 57.6067 31.314 57.3765 31.2426C57.1462 31.1711 56.9042 31.1458 56.6641 31.1679C56.4241 31.19 56.1908 31.2592 55.9775 31.3715C55.7642 31.4838 55.5751 31.6371 55.421 31.8224C55.2669 32.0078 55.1508 32.2217 55.0794 32.452C55.008 32.6822 54.9827 32.9243 55.0048 33.1643C55.0269 33.4043 55.0961 33.6377 55.2084 33.851C55.3207 34.0643 55.4739 34.2534 55.6593 34.4074C57.1297 35.5439 58.3274 36.9947 59.1649 38.6537C60.0023 40.3126 60.4582 42.1379 60.4993 43.9958C60.4582 45.8537 60.0023 47.6789 59.1649 49.3379C58.3274 50.9969 57.1297 52.4477 55.6593 53.5841C55.4737 53.738 55.3202 53.927 55.2077 54.1403C55.0953 54.3536 55.026 54.587 55.0038 54.8272C54.9817 55.0673 55.0071 55.3094 55.0787 55.5397C55.1503 55.77 55.2666 55.9839 55.421 56.1691C55.5934 56.3761 55.8092 56.5425 56.0532 56.6566C56.2972 56.7706 56.5633 56.8296 56.8327 56.8291C57.261 56.83 57.6761 56.6808 58.006 56.4074C59.8951 54.9306 61.4291 53.0489 62.4952 50.901C63.5612 48.7531 64.1322 46.3935 64.166 43.9958C64.1322 41.5981 63.5612 39.2385 62.4952 37.0906C61.4291 34.9426 59.8951 33.061 58.006 31.5841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.527 27.7183C48.2483 27.5574 47.9322 27.4727 47.6104 27.4727C47.2885 27.4727 46.9724 27.5574 46.6937 27.7183L34.832 35.8766H25.6654C25.1791 35.8766 24.7128 36.0698 24.369 36.4136C24.0252 36.7574 23.832 37.2237 23.832 37.7099V50.2866C23.832 50.7728 24.0252 51.2392 24.369 51.583C24.7128 51.9268 25.1791 52.1199 25.6654 52.1199H34.832L46.5837 60.1866C46.9056 60.3949 47.282 60.5034 47.6654 60.4983C48.1516 60.4983 48.6179 60.3051 48.9617 59.9613C49.3055 59.6175 49.4987 59.1512 49.4987 58.6649V29.3316C49.4978 29 49.407 28.6747 49.2359 28.3906C49.0648 28.1065 48.8198 27.8742 48.527 27.7183Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7416_16902",
    x1: 88,
    y1: 88,
    x2: -11.7947,
    y2: 71.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#710EDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A856FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7416_16902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(22 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListen);
export default __webpack_public_path__ + "static/media/listen.92fedc44115dbe6e21869e0321e4c375.svg";
export { ForwardRef as ReactComponent };